export default "__VITE_ASSET__C5992aFF__"